import React, { FC, useState } from 'react';
import toast, { LoaderIcon } from 'react-hot-toast';
import { Box } from '@mui/material';
import { IQrEntry, ISingleQrOperations } from './constants';
import axiosInstant from '../../../api';
import { qrCodeEndpoint } from '../../../api/endpoints';
import config from '../../../config';
import { ConfirmationDialog } from '../../../components/Modal/ConfirmationDialog';
import { QrEntryMenu } from './QrEntryMenu';

interface Props extends ISingleQrOperations {
  entry: IQrEntry;
  isDetailedPage?: boolean;
  onClose?: () => void;
}

export const QrMenuContainer: FC<Props> = ({
  onUpdate,
  onRemove,
  onEdit,
  ...rest
}) => {
  const { entry } = rest;
  const [shouldDelete, setShouldDelete] = useState(false);
  const [loading, setLoading] = useState(false);

  const onStatusChange = async (deactivated: boolean) => {
    if (!entry?.id) return;
    setLoading(true);
    const url = `${config.API_URL}${qrCodeEndpoint}/${entry.id}`;
    try {
      const { data } = await axiosInstant.patch(url, { ...entry, deactivated });
      onUpdate?.(data);
    } catch (err) {
      toast.error('Failed to update QR status');
    } finally {
      setLoading(false);
    }
  };

  const deleteQr = async (id?: number) => {
    if (!id) return;
    setShouldDelete(false);
    setLoading(true);
    try {
      await axiosInstant.delete(`${config.API_URL}${qrCodeEndpoint}/${id}`);
      toast.success('QR code deleted successfully!');
      onRemove?.(id);
    } catch (err) {
      toast.error('Failed to delete QR code');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box onClick={(e) => e.stopPropagation()} className="items-center flex">
      {loading && (
        <div className="w-7 h-7 flex items-center justify-center">
          <LoaderIcon />
        </div>
      )}
      {!loading && (
        <QrEntryMenu
          {...rest}
          onEdit={() => onEdit?.(entry)}
          onDeactivate={() => onStatusChange(true)}
          onActivate={() => onStatusChange(false)}
          onDelete={() => setShouldDelete(true)} // deleteQr(entry.id)}
        />
      )}
      {shouldDelete && (
        <ConfirmationDialog
          title="Delete QR"
          description={`Are you sure you want to delete '${entry.name} QR'? This action cannot be undone.`}
          show
          confirmLabel="Delete QR"
          onConfirm={() => deleteQr(entry?.id)}
          onCancel={() => setShouldDelete(false)}
        />
      )}
    </Box>
  );
};
